export default __webpack_public_path__ + "static/media/fridge1-before2-1920w.562445d8.avif";